import React from 'react';

import {ReceiveCashRefundForm} from './components';
import './styles.css';

const ReceiveCashRefund = ({
  delayExtraActions,
  tenancyId,
  creditNoteId,
  getExtraActions,
  scheduleType,
  locationRef,
  storeDataExtraActions
}) => {
  return (
    <div className="ReceiveCashRefund">
      <div className="horizontalLine" />

      <div className="header">Receive a cash refund</div>
      <ReceiveCashRefundForm
        delayExtraActions={delayExtraActions}
        tenancyId={tenancyId}
        creditNoteId={creditNoteId}
        getExtraActions={getExtraActions}
        scheduleType={scheduleType}
        storeDataExtraActions={storeDataExtraActions}
        locationRef={locationRef}
      />
      <div className="horizontalLine" />
    </div>
  );
};

export default ReceiveCashRefund;
